<style lang="less" scoped>
.root-edit-modal {
    padding: 0
}
</style>
<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="showModal"
        scrollable
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">已获批额度</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-form
                  ref="form"
                  :value="true"
                  style="width: 100%;"
                >
                  <v-col
                    cols="12"
                  >
                    <v-menu
                      v-model="showDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="dateToquarter(quarter_start_at)"
                          label=""
                          placeholder="季度起始时间*"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="quarter_start_at"
                        type="month"
                        no-title
                        scrollable
                        reactive
                        locale="zh-cn"
                        :allowed-dates="allowedMonths"
                        @change="changeDate"
                      />
                    </v-menu>
                  </v-col>
                </v-form>
                <v-col
                  cols="12"
                >
                  <!--   :loading="loading" -->
                  <v-data-table
                    ref="test"
                    style="width:100%"
                    class="table"
                    :headers="tableFields"
                    :items="tableList"
                    :loading="loading"
                    loading-text="数据加载中..."
                    hide-default-footer
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="cancel"
            >
              关闭
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
  import { budgetAmountQuarterAmountApi } from '../service'
  import { formattingNumber } from '@/libs/util'
  const quarter_start = ['01', '04', '07', '10']
  export default {
    data() {
      return {
        showModal: false,
        loading: false,
        quarter_start_at:'',
        showDateMenu:false,
        canEdit: false,
        list: []
      }
    },
    computed: {
      tableFields() {
        const arr = []
        this.list.forEach(({ month }) => {
          arr.push({
            text: month.slice(0, 7),
            value: month,
            align: 'right',
            sortable: false,
          })
        })
        arr.sort((a, b) => a.text - b.text)
        arr.push({
          text: '合计',
          value: 'total',
          align: 'right',
          sortable: false,
        })
        
        return arr
      },
      tableList() {
        const obj = {}
        let total = 0
        this.list.forEach(({month, amount}) => {
          obj[month] = formattingNumber(amount, 2)
          total = math.eval(`${total}+${amount}`)
        })
        obj.total = formattingNumber(total.toFixed(2), 2)
        return [obj]
      }
    },
    methods: {
      changeDate(date) {
        this.showDateMenu = false
        this.loading = true
        budgetAmountQuarterAmountApi({
          quarter_start: date + '-01'
        }).then((data = {}) => {
          this.list = data.amounts
        }).finally(() => {
          this.loading = false
        })
      },
      dateToquarter(date = '') { // 绑定季度展示
        if (!date) {
          return ''
        }
        const date_n = Number(date.slice(-2))
        return `${date}【第${Math.ceil(date_n / 3)}季度】`
      },
      allowedMonths(date) { // 季度开始月份可选
        const select_month = date.slice(-2)
        const is_start = quarter_start.includes(select_month) // 季度开始的月份
        if (is_start) {
          return true
        }
        return false
      },
      show() {
        this.showModal = true
        const current_quarter = this.dateToquarter(moment().format('YYYY-MM')).slice(0, 7)
        this.quarter_start_at = current_quarter
        this.changeDate(current_quarter)
      },
      cancel() {
        this.showModal = false
        this.showDateMenu = false
        this.$refs.form.resetValidation()
      },
    }
  }
</script>
